import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import BASE_URL from "../../BASEURL";

export default function AddProduct() {
    const navigate = useNavigate();

    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const res = await fetch(`${BASE_URL}/api/category`);
                if (!res.ok) return;
                const json = await res.json();
                setCategories(Array.isArray(json.data) ? json.data : []);
            } catch (err) {
                console.error('Failed to fetch categories:', err);
            }
        };
        fetchCategories();
    }, []);

    const [formData, setFormData] = useState({
        category: "", // will store category _id
        slug: "",
        name: "",
        shortDesc: "",
        description: "",
        videoUrl: "",
        brochure: "",
        applications: [""],
        features: [""],
        image: "",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleArrayChange = (index, field, value) => {
        const updated = [...formData[field]];
        updated[index] = value;
        setFormData({ ...formData, [field]: updated });
    };

    const addPoint = (field) => {
        setFormData({ ...formData, [field]: [...formData[field], ""] });
    };

    const removePoint = (index, field) => {
        const updated = formData[field].filter((_, i) => i !== index);
        setFormData({ ...formData, [field]: updated });
    };

    const [errors, setErrors] = useState({});
    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData({ ...formData, brochure: file });
        }
    };



    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData({ ...formData, image: file });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Client-side validation
        const newErrors = {};
        if (!formData.category) newErrors.category = 'Category is required.';
        if (!formData.slug) newErrors.slug = 'Slug is required.';
        if (!formData.name) newErrors.name = 'Name is required.';
        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) return;

        try {
            const form = new FormData();
            form.append('category', formData.category);
            form.append('slug', formData.slug);
            form.append('name', formData.name);
            form.append('shortDesc', formData.shortDesc);
            form.append('description', formData.description);
            form.append('videoUrl', formData.videoUrl);
            if (formData.brochure instanceof File) form.append('brochure', formData.brochure);
            if (formData.image instanceof File) form.append('image', formData.image);
            formData.applications.forEach((app, i) => form.append(`applications[${i}]`, app));
            formData.features.forEach((f, i) => form.append(`features[${i}]`, f));

            const res = await fetch(`${BASE_URL}/api/product`, {
                method: 'POST',
                body: form,
            });
            if (!res.ok) {
                const txt = await res.text();
                throw new Error(txt || 'Save failed');
            }
            alert('Product added!');
            navigate('/admin/productslist');
        } catch (err) {
            alert('Failed to add product');
        }
    };


    // Find selected category name for display if needed
    const selectedCategory = categories.find(
        (cat) => (cat._id || cat.id) === formData.category
    );

    return (
        <section className="max-w-5xl mx-auto p-6 bg-white shadow rounded">
            <h1 className="text-2xl font-bold text-primaryDark mb-6">
                Add New Product
            </h1>

            <div className="space-y-4">

                <select
                    name="category"
                    value={formData.category}
                    onChange={handleChange}
                    className="w-full border p-2 rounded bg-white"
                >
                    <option value="">Select Category</option>
                    {categories.map((cat) => (
                        <option key={cat._id || cat.id} value={cat._id || cat.id}>
                            {cat.name || cat.title || cat.slug}
                        </option>
                    ))}
                </select>


                <input
                    name="slug"
                    value={formData.slug}
                    onChange={handleChange}
                    className="w-full border p-2 rounded"
                    placeholder="Product Slug (e.g. blower-machine)"
                />
                {errors.slug && <div className="text-red-500 text-sm mt-1">{errors.slug}</div>}

                <input
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full border p-2 rounded"
                    placeholder="Product Name"
                />
                {errors.name && <div className="text-red-500 text-sm mt-1">{errors.name}</div>}

 <textarea
          name="shortDesc"
          value={formData.shortDesc}
          onChange={handleChange}
          className="w-full border p-2 rounded"
          placeholder="Short Description"
        />
                <textarea
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    className="w-full border p-2 rounded h-32"
                    placeholder="Full Description"
                />
                <div>
                    <h3 className="font-semibold text-primaryDark">Product Image</h3>
                    <input
                        type="file"
                        accept="image/*"
                        onChange={handleImageUpload}
                        className="w-full border p-2 rounded"
                    />
                    {formData.image && (
                        <p className="text-sm text-gray-600 mt-1">Selected: {formData.image.name || formData.image}</p>
                    )}
                </div>


                {/* APPLICATIONS */}
                <div>
                    <h3 className="font-semibold text-primaryDark">Applications</h3>
                    {formData.applications.map((app, i) => (
                        <div key={i} className="flex gap-2 mb-2">
                            <input
                                value={app}
                                onChange={(e) =>
                                    handleArrayChange(i, "applications", e.target.value)
                                }
                                className="w-full border p-2 rounded"
                            />
                            <button
                                onClick={() => removePoint(i, "applications")}
                                className="text-red-500"
                            >
                                ✕
                            </button>
                        </div>
                    ))}
                    <button
                        onClick={() => addPoint("applications")}
                        className="text-primary text-sm"
                    >
                        + Add Application
                    </button>
                </div>

                {/* FEATURES */}
                <div>
                    <h3 className="font-semibold text-primaryDark">Key Features</h3>
                    {formData.features.map((f, i) => (
                        <div key={i} className="flex gap-2 mb-2">
                            <input
                                value={f}
                                onChange={(e) =>
                                    handleArrayChange(i, "features", e.target.value)
                                }
                                className="w-full border p-2 rounded"
                            />
                            <button
                                onClick={() => removePoint(i, "features")}
                                className="text-red-500"
                            >
                                ✕
                            </button>
                        </div>
                    ))}
                    <button
                        onClick={() => addPoint("features")}
                        className="text-primary text-sm"
                    >
                        + Add Feature
                    </button>
                </div>

                {/* BROCHURE */}
                <div>
                    <h3 className="font-semibold text-primaryDark">Brochure PDF</h3>
                    <input
                        type="file"
                        accept="application/pdf"
                        onChange={handleFileUpload}
                        className="w-full border p-2 rounded"
                    />
                    {formData.brochure && (
                        <p className="text-sm text-gray-600 mt-1">Selected: {formData.brochure.name || formData.brochure}</p>
                    )}
                </div>

                <div className="flex gap-3 pt-6">
                    <button
                        onClick={handleSubmit}
                        className="bg-primary text-white px-6 py-2 rounded hover:bg-primaryDark"
                    >
                        Add Product
                    </button>

                    <button
                        onClick={() => navigate("/admin/productslist")}
                        className="border px-6 py-2 rounded"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </section>
    );
}
